import { CustomerStatistics } from 'store/services/types';

export interface Metric {
  label: string;
  id: keyof CustomerStatistics;
  format: 'currency' | 'number' | 'percent';
  description: string;
  hasTimeseries: boolean;
}

export const overall: Metric[] = [
  {
    label: 'Customers',
    id: 'num_buyers',
    format: 'number',
    description:
      'Count of unique customers who made a purchase in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'Orders',
    id: 'num_orders',
    format: 'number',
    description: 'Count of orders made in the specified date range.',
    hasTimeseries: true,
  },
  {
    label: 'Discounts',
    id: 'discount_ratio',
    format: 'percent',
    description: 'Discounts / (Net revenue + Discounts)',
    hasTimeseries: true,
  },
  {
    label: 'Net Revenue',
    id: 'total_revenue',
    format: 'currency',
    description: 'Sales - Discounts - Returns',
    hasTimeseries: true,
  },
  {
    label: 'Gross profit',
    id: 'gross_profit',
    format: 'currency',
    description: 'Net revenue - CoGS',
    hasTimeseries: true,
  },
  {
    label: 'Gross margin',
    id: 'gross_margin',
    format: 'percent',
    description: 'Gross profit / Net revenue',
    hasTimeseries: true,
  },
  {
    label: 'ANO',
    id: 'ano',
    format: 'number',
    description:
      'Avg number of orders made by each customer in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'ARPU',
    id: 'arpu',
    format: 'currency',
    description: 'Avg revenue per user in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'AOV',
    id: 'aov',
    format: 'currency',
    description: 'Avg. order value',
    hasTimeseries: true,
  },
];

const acquisition: Metric[] = [
  {
    label: 'New signups',
    id: 'num_signups',
    format: 'number',
    description:
      'Customers who created an account in your store in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'New customers',
    id: 'num_buyers',
    format: 'number',
    description:
      'Count of unique customers who made a purchase in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'Conversion rate',
    id: 'buyer_user_ratio',
    format: 'percent',
    description: 'New customers / New signups',
    hasTimeseries: false,
  },
  {
    label: 'Orders',
    id: 'num_orders',
    format: 'number',
    description: 'Count of orders made in the specified date range.',
    hasTimeseries: true,
  },
  {
    label: 'Discounts',
    id: 'discount_ratio',
    format: 'percent',
    description: 'Discounts / (Net revenue + Discounts)',
    hasTimeseries: true,
  },
  {
    label: 'Net Revenue',
    id: 'total_revenue',
    format: 'currency',
    description: 'Sales - Discounts - Returns',
    hasTimeseries: true,
  },
  {
    label: 'Gross profit',
    id: 'gross_profit',
    format: 'currency',
    description: 'Net revenue - CoGS',
    hasTimeseries: true,
  },
  {
    label: 'Gross margin',
    id: 'gross_margin',
    format: 'percent',
    description: 'Gross profit / Net revenue',
    hasTimeseries: true,
  },
  {
    label: 'ARPU',
    id: 'arpu',
    format: 'currency',
    description: 'Avg revenue per user in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'AOV',
    id: 'aov',
    format: 'currency',
    description: 'Avg. order value',
    hasTimeseries: true,
  },
];

const activation: Metric[] = [
  {
    label: 'New signups',
    id: 'num_buyers',
    format: 'number',
    description:
      'Users signed up previously who made an order in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'Orders',
    id: 'num_orders',
    format: 'number',
    description: 'Count of orders made in the specified date range.',
    hasTimeseries: true,
  },
  {
    label: 'Discounts',
    id: 'discount_ratio',
    format: 'percent',
    description: 'Discounts / (Net revenue + Discounts)',
    hasTimeseries: true,
  },
  {
    label: 'Net Revenue',
    id: 'total_revenue',
    format: 'currency',
    description: 'Sales - Discounts - Returns',
    hasTimeseries: true,
  },
  {
    label: 'Gross profit',
    id: 'gross_profit',
    format: 'currency',
    description: 'Net revenue - CoGS',
    hasTimeseries: true,
  },
  {
    label: 'Gross margin',
    id: 'gross_margin',
    format: 'percent',
    description: 'Gross profit / Net revenue',
    hasTimeseries: true,
  },
  {
    label: 'ARPU',
    id: 'arpu',
    format: 'currency',
    description: 'Avg revenue per user in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'AOV',
    id: 'aov',
    format: 'currency',
    description: 'Avg. order value',
    hasTimeseries: true,
  },
];
const retention: Metric[] = [
  {
    label: 'Repeat customers',
    id: 'num_buyers',
    format: 'number',
    description:
      'Customers who purchased previously and repurchased during the specified date range',
    hasTimeseries: true,
  },
  // {
  //   label: 'Repeat customers rate',
  //   id: 'return_num_buyer_ratio',
  //   format: 'percent',
  //   description: 'Repeat customers / Total customers',
  //   hasTimeseries: true,
  // },
  {
    label: 'Orders',
    id: 'num_orders',
    format: 'number',
    description: 'Count of orders made in the specified date range.',
    hasTimeseries: true,
  },
  {
    label: 'Discounts',
    id: 'discount_ratio',
    format: 'percent',
    description: 'Discounts / (Net revenue + Discounts)',
    hasTimeseries: true,
  },
  {
    label: 'Net Revenue',
    id: 'total_revenue',
    format: 'currency',
    description: 'Sales - Discounts - Returns',
    hasTimeseries: true,
  },
  {
    label: 'Gross profit',
    id: 'gross_profit',
    format: 'currency',
    description: 'Net revenue - CoGS',
    hasTimeseries: true,
  },
  {
    label: 'Gross margin',
    id: 'gross_margin',
    format: 'percent',
    description: 'Gross profit / Net revenue',
    hasTimeseries: true,
  },
  {
    label: 'ARPU',
    id: 'arpu',
    format: 'currency',
    description: 'Avg revenue per user in the specified date range',
    hasTimeseries: true,
  },
  {
    label: 'AOV',
    id: 'aov',
    format: 'currency',
    description: 'Avg. order value',
    hasTimeseries: true,
  },
];

const churn: Metric[] = [
  {
    label: 'Churned users',
    id: 'num_churned',
    format: 'number',
    description:
      'Number of customers leaving the business over a specified date range according to the RFM model',
    hasTimeseries: true,
  },
  {
    label: 'Acquisition to Churn Rate (ACR)',
    id: 'acq_to_churn_rate',
    format: 'percent',
    description: 'New users / Churned users',
    hasTimeseries: false,
  },
];

export const getMetrics = (type: string) => {
  switch (type) {
    case 'overall':
      return overall;
    case 'acquisition':
      return acquisition;
    case 'activation':
      return activation;
    case 'retention':
      return retention;
    case 'churn':
      return churn;
    default:
      return [];
  }
};
